import { useMutation } from '@tanstack/react-query';
import { fetchProcessedFile } from '../api/uploads';

const useDownloadProcessedFile = () =>
  useMutation({ mutationFn: fetchProcessedFile });

export default useDownloadProcessedFile;
